import axios from 'axios';
import authHeader from '../services/AuthHeader';
import {ENV_URL} from './Globals';
const MEMBERS_API_URL = `${ENV_URL}/api/v1/members`;


class MemberDataService {
    //GET All Members 
    getAllMembers() {
        return axios.get(`${MEMBERS_API_URL}`, {
            headers: authHeader()
        });
    };


    //CREATE Member 
    createMember(data) {
        return axios.post(`${MEMBERS_API_URL}`, data , {
                headers: authHeader()
        });
    }

    //GET Member (give Id)
    getMember(id) {
        return axios.get(`${MEMBERS_API_URL}/${id}`, {
            headers: authHeader() 
        });
    };


    //UPDATE  Member (given ID and body)
    updateMember(id,data) {
        return axios.put(`${MEMBERS_API_URL}/${id}`, data , {
            headers: authHeader()
        });
    };

    //DELETE  Memebr 
    deleteMember(id) {
    return axios.delete(`${MEMBERS_API_URL}/${id}`, {
        headers: authHeader()
    });
};


//Add Child 
addChild(id,data) {
    return axios.post(`${MEMBERS_API_URL}/${id}/addchild`, data , {
        headers: authHeader()          
    });
};


//get Childrens 
getChildren(id) {
    return axios.get(`${MEMBERS_API_URL}/${id}/getchildren`, {
        headers: authHeader()
    });
};



//add Partner 
addPartner(id,data) {
    return axios.post(`${MEMBERS_API_URL}/${id}/addpartner`, data , {
        headers: authHeader()
    });
};

//get all Partners 
getPartners(id) {
    return axios.get(`${MEMBERS_API_URL}/${id}/getpartners`, {
        headers: authHeader()
    });
};


//get all Partners 
getOnePartner(memid,partnerid) {
    return axios.get(`${MEMBERS_API_URL}/${memid}/getonepartner/${partnerid}`, {
        headers: authHeader()
    });
};


//get Partner 
getParent(id) {
    return axios.get(`${MEMBERS_API_URL}/${id}/getparent`, {
        headers: authHeader()
    });
};


//get Profile Picture 
downloadUserProfileImage(id) {
    return axios.get(`${MEMBERS_API_URL}/${id}/download`, {
        headers: authHeader()
    });  
};

//upload Profile Picture
uploadUserProfileImage(id) {
    return axios.post(`${MEMBERS_API_URL}/${id}/upload`, {
        "file": "file",
        headers : authHeader()
    }
    ); 
};

getRootMember() {
    return axios.get(`${MEMBERS_API_URL}/getrootmember`, {
        headers: authHeader() 
    });
};



};

const memberDataService = new MemberDataService();
export default memberDataService;